module.exports = __webpack_public_path__ + "static/img/kh-16.a38ad03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kh-16.png
// module id = C9fc
// module chunks = 5